// extracted by mini-css-extract-plugin
export default {"container":"zWE_5jtE","backButtonContainer":"k_ysz4Tv","backButton":"G3QbDqj9"};